<fcom-loader
  *ngIf="(paxFormReady$ | async) === false"
  [loaderType]="LoaderTheme.INLINE"
  class="block ms-xxlarge-t"
></fcom-loader>

<div class="flex-1 pax-details-form" [formGroup]="paxForm" *ngIf="paxFormReady$ | async">
  <ng-container formArrayName="passengers">
    <ng-container *ngFor="let passenger of passengers.controls; let i = index">
      <div
        class="passenger container border rounded-large mr-xsmall-b white-bg"
        [attr.data-testid]="'passenger-' + i"
        [ngClass]="
          getBorderClasses({
            status: passenger.status,
            expanderIsOpen: paxExpandersOpen[i],
            allowErrorsVisible: paxAllowErrorsVisible[i],
          })
        "
      >
        <ng-container [formGroupName]="i">
          <fin-expander-card
            [expandOpen]="paxExpandersOpen[i]"
            [iconName]="
              passenger.status === PaxFormStatus.INVALID
                ? SvgLibraryIcon.SINGLE_PAX_BLOCK
                : SvgLibraryIcon.CHECKMARK_BLOCK
            "
            [iconClasses]="
              getIconClass({
                status: passenger.status,
                expanderIsOpen: paxExpandersOpen[i],
                allowErrorsVisible: this.paxAllowErrorsVisible[i],
              })
            "
            [descriptionContent]="descriptionContent"
            [descriptionClasses]="
              !paxExpandersOpen[i] && passenger.status === PaxFormStatus.INVALID && this.paxAllowErrorsVisible[i]
                ? 'error-900-text'
                : ''
            "
            [title]="('paxDetails.passenger' | finLocalization) + ' ' + passenger.get('number').value"
            [subTitle]="
              (paxTypeLocalizationKey(passenger.get(FIELDS.type).value) | finLocalization) +
              ' ' +
              (paxAgeLocalizationKey(typeLocalizationKeys[i]) | finLocalization)
            "
            (expandChange)="toggleOpen(passenger, $event, i)"
          >
            <ng-container ngProjectAs="expandedContent">
              <div class="expanded-content ps-medium-x ps-medium-b">
                <fin-pax-details-form-group
                  [groupIndex]="i"
                  [passengerFormGroup]="passenger"
                  [profileType$]="profileType$"
                  [profile$]="profile$"
                  [corporateUsers$]="corporateUsers$"
                  [isMainPassenger]="i === 0"
                  [controlData]="controlData$ | async"
                  [frequentFlyerAirlines$]="frequentFlyerAirlines$[i]"
                  [availableDates]="availableDays[i]"
                  [trackingContext]="TRACKING_CONTEXT"
                  (focusEvent)="onFocusField($event)"
                  (blurEvent)="onBlurField()"
                  (corporateUserSelected)="corporateUserSelected($event)"
                  (corporateUserCleared)="corporateUserCleared($event)"
                >
                </fin-pax-details-form-group>

                <div
                  *ngIf="passenger.get(FIELDS.type).value === C.FinnairPassengerCode.INF"
                  class="traveling-with-area border-none pr-xsmall-b"
                  [class.locked]="infantTravelingWithLocked$ | async"
                  data-hj-suppress
                >
                  <fin-select-input
                    class="block ms-small-b"
                    [controlName]="FIELDS.travelling"
                    [translationPrefix]="'paxDetails.fields.travelling'"
                    [parentForm]="passenger"
                    [required]="true"
                    [options]="selectableLeadPassengers$ | async"
                    (blur)="onBlurField()"
                    [attr.data-testid]="'infant'"
                    [displayMargin]="false"
                  >
                  </fin-select-input>
                  <fcom-notification
                    *ngIf="infantTravelingWithLocked$ | async"
                    [theme]="NotificationTheme.WARNING"
                    [horizontal]="true"
                    [linkText]="
                      ((cartStatus$ | async) === CART_STATUS.PENDING
                        ? 'paxDetails.fields.travelling.unlockLoading'
                        : 'paxDetails.fields.travelling.unlockCTA'
                      ) | finLocalization
                    "
                    (linkClick)="onUnlockTravelingWith($event)"
                  >
                    {{ 'paxDetails.fields.travelling.lockedInfo' | finLocalization }}
                  </fcom-notification>
                </div>
              </div>
            </ng-container>
          </fin-expander-card>

          <ng-template #descriptionContent>
            {{
              !paxExpandersOpen[i] && passenger.status === PaxFormStatus.INVALID && this.paxAllowErrorsVisible[i]
                ? ('paxDetails.missingPaxDetails' | finLocalization)
                : (paxSummary$ | async)?.[i]
            }}
          </ng-template>
        </ng-container>
      </div>
    </ng-container>
    <div class="is-vishidden" aria-live="'polite'">
      {{
        ((servicesReady$ | async) === false
          ? 'paxDetails.paxAncillaries.updatingPrices'
          : (paxServices$ | async)
            ? 'paxDetails.paxAncillaries.pricesUpdated'
            : ''
        ) | finLocalization
      }}
    </div>
  </ng-container>

  <h4 class="font-body-1 mr-medium-t mr-small-b">{{ 'paxDetails.more' | finLocalization }}</h4>
  <div
    *ngIf="enableAdditionalEmailInBookingFlow"
    class="container white-bg mr-xsmall-b corporate-booking border rounded-large"
    [ngClass]="
      getCorporateBorderClasses({
        corporateExpanderOpen: corporateExpanderOpen,
        errors: paxForm.get('additionalEmail').errors,
        value: paxForm.get('additionalEmail').value,
      })
    "
  >
    <fin-expander-card
      [expandOpen]="corporateExpanderOpen"
      [iconName]="SvgLibraryIcon.CORPORATE_BOOKING_BLOCK"
      [iconClasses]="
        getCorporateIconClass({
          expanderIsOpen: corporateExpanderOpen,
          errors: paxForm.get('additionalEmail').errors,
          value: paxForm.get('additionalEmail').value,
        })
      "
      [title]="'paxDetails.fields.corporate.title' | finLocalization"
      [descriptionClasses]="paxForm.get('additionalEmail').errors ? 'error-900-text' : ''"
      (expandChange)="toggleOpenCorporate($event)"
      [attr.data-testid]="'corporate-booking'"
    >
      <ng-container ngProjectAs="expandedContent">
        <div class="ps-medium-x ps-medium-b">
          <fin-additional-email
            class="block expanded-content"
            [attr.data-testid]="'additional-email'"
            [parentForm]="paxForm"
            [controlName]="'additionalEmail'"
            [emailsArray]="emailsArray"
            [placeholder]="'additionalEmail.placeholder'"
            [disabledPlaceholder]="'additionalEmail.disabledPlaceholder'"
            [buttonText]="'additionalEmail.button'"
            (addEmail)="addEmail()"
            (removeEmail)="removeEmail($event)"
          ></fin-additional-email>
        </div>
      </ng-container>
    </fin-expander-card>
  </div>

  <fin-pax-details-marketing-consent #marketingConsent [passengers]="passengers"></fin-pax-details-marketing-consent>

  <fin-pax-shortcut-to-pay [cartData$]="cartData$" (buttonClick)="handleShortcutToPayClick()"></fin-pax-shortcut-to-pay>

  <fin-multi-city-survey class="block mr-small-b"></fin-multi-city-survey>
</div>
<fcom-cta-button
  data-testid="cta-pax-form-continue-button"
  [visible]="true | finToObservable | finDelay | async"
  [title]="'actions.next' | finLocalization"
  [position]="ButtonPosition.GRID"
  [loading]="loading"
  (click)="validateForm()"
  (buttonClicked)="paxDetailsReady()"
>
  <div class="flex flex--center flex--middle">
    <span>
      <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
      <span *ngIf="totalPoints$ | async as points" class="font-body-1" data-testid="cta-points">
        {{ 'award.points' | finLocalization: { pointsAmount: points || 0 | finPoints } }}&nbsp;+&nbsp;</span
      >
      <span class="font-body-1 bold-type" data-testid="cta-price">{{
        totalPrice$ | async | finPrice | finEmpty: '&ndash;'
      }}</span>
    </span>
    <span>
      <fcom-icon
        *ngIf="(priceUpdating$ | async) || (servicesReady$ | async) === false"
        class="ms-xsmall-l icon-medium loading-icon"
        [name]="SvgLibraryIcon.TRANSFER_LOADER"
        [attr.aria-label]="'ctaButton.loading' | finLocalization"
      ></fcom-icon>
    </span>
  </div>
</fcom-cta-button>
